module.exports = __webpack_public_path__ + "static/Cube-1fb459a99b2c2ba8a30d8ef6f52b1d9b.svg";